import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes as ReactRoutes } from "react-router-dom";
import { useAuthContext } from "../state/authentication/context";
import AppSectionContainer from "../views/common/containers/AppSectionContainer";
import { baseURL } from "./game-routes";

const Routes = ({ routeConfig }) => {
	const { state } = useAuthContext();
	const isAuthenticated = state.isAuthenticated();

	const routes = Object.values(routeConfig).map((route) => {
		let SectionRoute = (
			<Route path={route.url} key={route.id} element={route.component} />
		);

		if (route.appSection) {
			const Component = <AppSectionContainer appSection={route.appSection} />;
			// HACK for rr v6. Nested routes do not have to be prefixed with the parent path. https://reactrouter.com/en/main/start/faq
			SectionRoute = (
				<Route
					path={route.url.replace(baseURL, "")}
					key={route.id}
					element={Component}
				/>
			);
		}
		if (typeof route.component === "string") {
			const Component = lazy(() => import(`../views/${route.component}`));
			SectionRoute = (
				<Route path={route.url} key={route.id} element={<Component />} />
			);
		}

		return route.isPrivate && !isAuthenticated ? (
			<Route
				path={route.url}
				key={route.id}
				element={<Navigate to={routeConfig.LOGIN.url} key={route.id} />}
			/>
		) : (
			SectionRoute
		);
	});

	return (
		<Suspense fallback={<div />}>
			<ReactRoutes>
				{routes.map((r) => r)}
				<Route path="*" element={<div>Route not found</div>} key="default" />
			</ReactRoutes>
		</Suspense>
	);
};

export default Routes;
